import React, { useContext } from 'react';

import Skeleton from '@components/Skeleton';

import { DISPLAY_3_LATEST_REVIEWS } from '@constants/hotels';

import { GlobalContext } from '@context/GlobalContext';

import styles from './HotelCardSkeleton.module.scss';

export interface HotelCardSkeletonProps {
  isLoading?: boolean;
  hotelViewModelsLength?: number;
  numberOfSkeletons?: number;
}

const HotelCardSkeleton: React.FC<HotelCardSkeletonProps> = ({
  isLoading,
  hotelViewModelsLength,
  numberOfSkeletons = 2,
}): JSX.Element => {
  const { userCentricCoreConfigs } = useContext(GlobalContext);

  const isDisplayLatestReviews =
    userCentricCoreConfigs.find((coreConfig) => coreConfig.key === DISPLAY_3_LATEST_REVIEWS)
      ?.value === '1';

  return (
    <>
      {isLoading && hotelViewModelsLength === 0
        ? [...Array(numberOfSkeletons).keys()].map((value: number, index: number) => (
            <div
              data-testid={`hotelCardSkeleton-${index}`}
              key={value}
              className={styles.hotelCardSkeleton}
            >
              <Skeleton className={styles.imageGallery} width={240} height={240} borderRadius={8} />

              <div className={styles.detailContainer}>
                <div className={styles.detail}>
                  <div className={styles.hotelDetail}>
                    <Skeleton className={styles.name} width={'97%'} height={20} borderRadius={4} />
                    <Skeleton
                      className={styles.nameOverflow}
                      width={'50%'}
                      height={20}
                      borderRadius={4}
                    />
                    <Skeleton
                      className={styles.starAndDistrictAndDistanceFrom}
                      width={'50%'}
                      height={18}
                      borderRadius={4}
                    />
                  </div>

                  {isDisplayLatestReviews ? (
                    <div className={styles.hotelReviews}>
                      <Skeleton
                        className={styles.customer}
                        width={'97%'}
                        height={20}
                        borderRadius={4}
                      />
                      <Skeleton
                        className={styles.comment}
                        width={'50%'}
                        height={20}
                        borderRadius={4}
                      />
                    </div>
                  ) : null}
                </div>

                <div className={styles.bestDeal}>
                  <div className={styles.deal}>
                    <Skeleton className={styles.price} width={'90%'} height={20} borderRadius={4} />
                    <Skeleton
                      className={styles.priceType}
                      width={'45%'}
                      height={12}
                      borderRadius={4}
                    />
                  </div>

                  <Skeleton
                    className={styles.viewDeal}
                    width={'100%'}
                    height={36}
                    borderRadius={4}
                  />
                </div>
              </div>
            </div>
          ))
        : null}
    </>
  );
};

export default HotelCardSkeleton;
